import LoadingText from '@data/components/basic/LoadingText/LoadingText';

export function LoadingSelect() {
  return (
    <div className="flex w-44 flex-col justify-end gap-2">
      <LoadingText />
      <LoadingText size="lg" />
    </div>
  );
}
